import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { userApi } from "../../assets/apis";
import { userPermissionArray } from "./helper";
import axios from "axios";
import "./AddUser.css";
const AddUser = () => {
  const [addUserData, setAddUserData] = useState({});
  const [userPermissions, setUserPermissions] = useState([
    ...userPermissionArray,
  ]);
  const [selectedUserPermissions, setselectedUserPermissions] = useState([]);
  const [apiInProccess, setApiInProccess] = useState(false);
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data) => {
      return axios.post(userApi, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["users"]);
      toast.success("User saved successfully!");
      setApiInProccess(false);
      navigate("/users");
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message;
      setApiInProccess(false);
      toast.error(` ${errorMessage}`);
    },
  });

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setAddUserData((pre) => ({ ...pre, [name]: value }));
  };

  const handleChangeUserDataWithCondition = (e, validationRegex) => {
    const { name, value } = e.target;
    if (value === "" || validationRegex.test(value)) {
      setAddUserData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    const { name, email, mobile, password, designation } = addUserData;
    if (!name || !name.trim()) return toast.error("Please enter Name");

    if (!mobile || mobile?.length < 10)
      return toast.error("Please enter a valid Mobile number");

    if (!password || password?.length < 8)
      return toast.error("Password must be at least 8 characters");

    if (!selectedUserPermissions.length) {
      return toast.error("Please Select Atleast One User Permission");
    }

    let payload = {
      ...addUserData,
      ...(name && { name: name.trim() }),
      ...(email && { email: email.trim() }),
      ...(password && { password: password.trim() }),
      ...(designation && { designation: designation.trim() }),
      user_permission: selectedUserPermissions,
    };
    setApiInProccess(true);
    mutation.mutate(payload);
  };

  const handleSelectUserPermission = (clickedOption) => {
    if (
      selectedUserPermissions.some(
        (selectedPermission) => selectedPermission.value === 0
      )
    ) {
      setUserPermissions((pre) => [
        selectedUserPermissions[0],
        ...pre.filter((permission) => permission.value !== clickedOption.value),
      ]);
      setselectedUserPermissions((pre) => [clickedOption]);
      return;
    }
    if (clickedOption.value === 0 && selectedUserPermissions.length) {
      setUserPermissions(
        userPermissionArray.filter((permission) => permission.value !== 0)
      );
      setselectedUserPermissions((pre) => [clickedOption]);
      return;
    }
    setUserPermissions((pre) =>
      pre.filter((permission) => permission.value !== clickedOption.value)
    );
    const indexToInsert = selectedUserPermissions.findIndex(
      (permission) => permission.value > clickedOption.value
    );
    if (indexToInsert === -1) {
      setselectedUserPermissions((pre) =>
        pre.filter((permission) => permission.value !== clickedOption.value)
      );
      setselectedUserPermissions((pre) => [...pre, clickedOption]);
    } else {
      setselectedUserPermissions((pre) => [
        ...pre.slice(0, indexToInsert),
        clickedOption,
        ...pre.slice(indexToInsert),
      ]);
    }
  };

  const handleSelectedUserPermissions = (clickedOption) => {
    setselectedUserPermissions((pre) =>
      pre.filter((permission) => permission.value !== clickedOption.value)
    );
    const indexToInsert = userPermissions.findIndex(
      (permission) => permission.value > clickedOption.value
    );
    if (indexToInsert === -1) {
      setUserPermissions((pre) =>
        pre.filter((permission) => permission.value !== clickedOption.value)
      );
      setUserPermissions((pre) => [...pre, clickedOption]);
    } else {
      setUserPermissions((pre) => [
        ...pre.slice(0, indexToInsert),
        clickedOption,
        ...pre.slice(indexToInsert),
      ]);
    }
  };

  return (
    <div className={`main-panel`}>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between m-1 p-1 align-items-baseline ">
              <h3 className="ukhd mb-3">Add User</h3>
              <button
                type="button"
                className="btn btn-warning btn-sm"
                onClick={() => navigate("/users")}
              >
                <div className="d-flex justify-content-center">
                  <i className="mdi mdi mdi-keyboard-backspace"></i>
                  <span>Back</span>
                </div>
              </button>
            </div>
            <div className="row flex-grow">
              <div className="col-12 grid-margin stretch-card">
                <div className="card card-rounded">
                  <div className="card-body">
                    <div className="col-12 ">
                      <h5>USER INFORMATION</h5>
                    </div>
                    <form className="row" onSubmit={onSubmitHandler}>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>User Name *</label>
                          <input
                            required
                            value={addUserData.name || ""}
                            onChange={(e) =>
                              handleChangeUserDataWithCondition(
                                e,
                                /^[a-zA-Z\s\b]+$/
                              )
                            }
                            name="name"
                            type="text"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Email *</label>
                          <input
                            required
                            value={addUserData.email || ""}
                            onChange={handleOnChange}
                            name="email"
                            type="email"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Mobile *</label>
                          <input
                            required
                            value={addUserData.mobile || ""}
                            name="mobile"
                            type="text"
                            className="form-control"
                            minLength={10}
                            maxLength={10}
                            onChange={(e) =>
                              handleChangeUserDataWithCondition(e, /^[0-9\b]+$/)
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Password *</label>
                          <input
                            required
                            value={addUserData.password || ""}
                            onChange={handleOnChange}
                            name="password"
                            type="password"
                            minLength={8}
                            maxLength={16}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>designation</label>
                            <input
                              value={addUserData.designation || ""}
                              onChange={handleOnChange}
                              name="designation"
                              type="text"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 row">
                        <div className="col-md-5 form-group">
                          <label>User Permissions</label>
                          <div className="select_list_container">
                            <ul className="value-list">
                              {userPermissions?.map((permission) => (
                                <li
                                  key={permission.value}
                                  onClick={() =>
                                    handleSelectUserPermission(permission)
                                  }
                                >
                                  {permission.label}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <div className="col-md-2 arrow_container">
                          <div>
                            <i
                              id="add_permission"
                              className="fa fa-arrow-right"
                              aria-hidden="true"
                            ></i>
                            <div>
                              <i
                                id="remove_permission"
                                className="fa fa-arrow-left"
                                aria-hidden="true"
                              ></i>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-5 form-group">
                          <label>Selected Permissions *</label>
                          <div className="select_list_container">
                            <ul className="value-list">
                              {selectedUserPermissions?.map((permission) => (
                                <li
                                  key={permission.value}
                                  className="selected-option"
                                  onClick={() =>
                                    handleSelectedUserPermissions(permission)
                                  }
                                >
                                  {permission.label}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <button
                          type="submit"
                          className="btn btn-primary d-flex justify-content-center px-3 py-2"
                          disabled={apiInProccess}
                        >
                          <i className="mdi mdi-content-save me-1"></i> Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
